import "@/style/index.scss";
import "@/utils/nav";
import "@/utils/tab.js"
import "@/utils/banner.js";
import "@/utils/information.js"
import "@/utils/member.js"
import "@/utils/website.js"
import accor from "@/utils/accordion";
import "@/style/accordion.scss";
import "@/utils/ft-carousel.min";
import "default-passive-events";

const sideItems = document.querySelectorAll(".n_side-item");
const navigationSide = $("#navigationSide");
// navigationSide.hide();

// new slidePage({
//   slideContainer: "#slide-container",
//   page: 1,
//   refresh: true,
//   // Events
//   before: function (origin, direction, target) {
//     const nowIdx = target - 1;
//     nowIdx === 0 ? navigationSide.hide() : navigationSide.show();
//     sideItems.forEach((item, idx) => {
//       item.className = "n_side-item";
//       if (nowIdx !== 0) item.className += " side-item__black";
//       if (idx === nowIdx) item.className += " side-item__active";
//     });
//   },
// });

accor($("#Accor4"), "50%", 500);

$("#ftCarousel").FtCarousel({
  index: 0,
  auto: true,
  time: 4000,
  indicators: false,
  buttons: true,
});

// $("#ftCarousel_news").FtCarousel({
//   index: 0,
//   auto: true,
//   time: 4000,
//   indicators: false,
//   buttons: true,
// });

const nav = $("#information").text()

// 会员列表
// $.get(develop + "/system/exc/official/menber/memberList?current=1&size=60", function (data) {
//   const list = data.data.records;
//   var contents = '';
//   $.each(list, function (i) {
//     if (list[i].logo !== null) {
//       const imgList = "<img src=" + list[i].logo + ">" + "</img>"
//       contents +=
//         '<li class=' + 'member-list__item ' + '>' +
//         '<a href=' + list[i].website + '>' +
//         imgList +
//         // "<img src=" + list[i].logo + ">" + "</img>" +
//         '</a>'
//       '</li>';
//       $(".member-list").html(contents);
//     }

//   });
// });

// 会员列表滚动
// window.onload = function () {
//   var odiv = document.getElementById('member-box');
//   var oul = odiv.getElementsByTagName('ul')[0];
//   var ali = oul.getElementsByTagName('li');
//   setTimeout(() => {
//     var spa = -2;
//     oul.innerHTML = oul.innerHTML + oul.innerHTML;
//     oul.style.width = ali[0].offsetWidth * ali.length + 'px';
//     function move() {
//       if (oul.offsetLeft < -oul.offsetWidth / 2) {
//         oul.style.left = '0';
//       }
//       if (oul.offsetLeft > 0) {
//         oul.style.left = -oul.offsetWidth / 2 + 'px'
//       }
//       oul.style.left = oul.offsetLeft + spa + 'px';
//     }
//     var timer = setInterval(move, 20)

//     odiv.onmouseenter = function () { clearInterval(timer); }
//     odiv.onmouseleave = function () { timer = setInterval(move, 20) };
//   }, 2000)
// }

const PageListSize = 8
let cateBg = ''
// 首页咨询分类模块数据渲染
$.get('/api/admin/official/exc/home/information', function (res) {
  const data = res.data
  // 是否是二级分类，二级分类不显示分类tab
  let isSubCate = false
  let cateId = ''
  let subCateId = ''
  if (!data) {
    $('.category-box').hide()
    return;
  }

  $('.category-box .page-title .title').html(data.name)
  cateBg = data.iconUrl
  if (data.optionsId) {
    let catesArray = data.optionsId.split('/')
    cateId = catesArray[0]
    if (catesArray.length > 1) {
      isSubCate = true
      subCateId = catesArray[1]

      const subCateName = data.optionsName
      $(".category-sub-name").html(subCateName)
    }
  }

  if (isSubCate) {
    getCategoryPageList(cateId, subCateId)
  } else {
    $.get('/api/admin/official/exc/informationCategory/list', { parentId: cateId }, function (list) {
      const listData = list.data
      let listHtml = ''

      $.each(listData, function (i) {
        listHtml +=
          `<div class="category-list" data-category-id="${listData[i].id}">
            ${listData[i].module}
          </div>`
        $(".category-list-box").html(listHtml)
      })

      if (listData.length) {
        getCategoryPageList(cateId, listData[0].id)
      } else {
        $(".category-box .more-btn").hide()
      }

      $(document).ready(function () {
        $(".category-list").eq(0).addClass("active-category")

        $(".category-list-box").on("click", ".category-list", function () {
          $(".category-list").removeClass("active-category");
          $(this).addClass("active-category");
          const listId = $(this).attr("data-category-id")
          getCategoryPageList(cateId, listId)
        });
      })
    })
  }
})

function getCategoryPageList(navId, listId, size = PageListSize) {
  $.get(`/api/admin/official/exc/informationPageList/${navId}/${listId}?current=1&size=${size}`, function (PageList) {
    const PageListData = PageList.data.records
    let PageListHtml = ''
    if (PageList.data.total === 0) {
      const noTextHtml =
        `<div class="no-text">
                  <img src="/static/images/vindicate-icon.png">
                  <p>暂无内容</p>
                </div>`
      $(".category-content-list-box").html(noTextHtml)
    } else {
      $.each(PageListData, function (i) {
        if (PageListData[i].subtitle === null) {
          PageListData[i].subtitle = ""
        }
        if (PageListData[i].coverUrl === "") {
          PageListData[i].coverUrl = "/static/images/bg.png"
        }
        if (PageListData[i].linkType === 0 || PageListData[i].linkType === null) {

          PageListHtml +=
            "<a class= " + 'content-list ' + "href=" + 'memberDetail.html?id=' + PageListData[i].id + '&nav=' + encodeURI(nav) + '&bg=' + cateBg + ">" +
            "<img class= " + 'content-img ' + "src=" + PageListData[i].coverUrl + ">" + "</img>" +
            '<div class="detail-title">' + PageListData[i].title + '</div>' +
            '<div class="content-detail">' +
            '<div class="detail-content">' + PageListData[i].subtitle + '</div>' +
            '<div class="detail-time">' + PageListData[i].publicTime + '</div>' +
            '</div>' +
            "</a>"
          $(".category-content-list-box").html(PageListHtml)
        } else {
          PageListHtml +=
            "<a class= " + 'content-list ' + "href=" + PageListData[i].linkUrl + ' target=_blank' + ">" +
            "<img class= " + 'content-img ' + "src=" + PageListData[i].coverUrl + ">" + "</img>" +
            '<div class="detail-title">' + PageListData[i].title + '</div>' +
            '<div class="content-detail">' +
            '<div class="detail-content">' + PageListData[i].subtitle + '</div>' +
            '<div class="detail-time ">' + PageListData[i].publicTime + '</div>' +
            '</div>' +
            "</a>"
          $(".category-content-list-box").html(PageListHtml)
        }
      })
    }

    const moreBtn = `<div class="more-btn">加载更多</div>`
    $('.category-box .operation-area').html(moreBtn)

    if (PageList.data.size >= PageList.data.total) {
      $(".category-box .more-btn").hide()
    } else {
      $(".category-box .more-btn").show()
    }

    $(document).ready(function () {
      let nextPageSize = size + PageListSize
      $(".more-btn").off('click')
      $(".more-btn").one('click', function () {
        getCategoryPageList(navId, listId, nextPageSize)
      })
    })
  })
}